module.exports = __webpack_public_path__ + "static/media/backbase.064d39c0.png";